module.exports = "<p>glossary works!</p>\r\n"